export default __webpack_public_path__ + "static/media/SG-LightBlue-0004.58af32cb.png";